import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import axios from 'axios'
import Loader from '../components/common/Loader'
import { loginUser, hideLoading } from '../redux/actions'
import { useAppDispatch, useAppSelector } from '../store'
import { localStorageManager } from '../utils/LocalStorageManager'

const Login = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const { user, loading } = useAppSelector((state) => state.auth)

    useEffect(() => {
        const initLogin = async () => {
            try {
                await ToktokdocLib.Utils.intializeSdk(
                    window._env_.REACT_APP_PARSE_URL,
                    window._env_.REACT_APP_PARSE_APPLICATION_ID,
                )
                ToktokdocLib.Toktokdoc.registerSubclass('_User', ToktokdocLib.User)
                // Parse.User.allowCustomUserClass(true)
                const uri = window.location.search.substring(1)
                const params = new URLSearchParams(uri)
                const requestFromOld = params.get('requestFromOld') || null

                if (requestFromOld) {
                    localStorageManager.set('pickedVersion', 'new')
                }

                const localToken = await ToktokdocLib.Utils.getSessionToken()

                try {
                    await ToktokdocLib.Parse.User.become(localToken)
                    dispatch(loginUser(localToken))
                } catch (error) {
                    try {
                        const res = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/login/sessionToken`, {
                            withCredentials: true,
                        })
                        if (res && res.status === 200) {
                            dispatch(loginUser(res.data.sessionToken))
                        }
                    } catch {
                        dispatch(hideLoading())
                        const hds = window._env_.REACT_APP_HDS_HOST
                        const auth = window._env_.REACT_APP_CUR_AUTH_CLBC
                        window.location.href = `${hds}/login?redirect=${auth}`
                    }
                }
            } catch (e) {
                console.error(e)
            }
        }

        initLogin()
    }, [])

    const defaultState = {
        from: {
            pathname: '/consultations',
        },
    }

    const { from } = !location.state ? defaultState : location.state

    return (
        <div>
            {loading && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '100vh',
                    }}
                >
                    <Loader />
                </div>
            )}
            {!user && <div id="login-form" />}
            {user && <Navigate replace to={from} />}
        </div>
    )
}

export default Login
